import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EditEngagementComponent } from './edit-engagement.component';
import { EditEngagementRoutingModule } from './edit-engagement-routing.module';
import { TreeTableModule } from 'primeng/treetable';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { PaginatorModule } from 'primeng/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EditorModule as Editor } from 'primeng/editor';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { PanelModule } from 'primeng/panel';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ManageDocComponent } from './components/manage-doc/manage-doc.component';
import { UploadNewDocComponent } from './components/upload-new-doc/upload-new-doc.component';
import { EditDocumentComponent } from './components/edit-doc/edit-doc.component';
import { ManageFolderComponent } from './components/manage-folder/manage-folder.component';
import { MatTabsModule } from '@angular/material/tabs';
import { FileUploadModule } from 'primeng/fileupload';
import { RDCServiceModule } from '../../framework/services/services.module';
import { TabViewModule } from 'primeng/tabview';
import { TreeModule } from 'primeng/tree';
import { TreeDragDropService } from 'primeng/api';
import { CalendarModule, TooltipModule } from 'primeng';
import { SidebarModule } from 'primeng/sidebar';
import { LanguageSelectionComponent } from './components/language-selection/language-selection.component';
import { BasicDetailsEditComponent } from './components/basic-details-edit/basic-details-edit.component';
import { AppConfigService } from '../../framework/services/app-config.service';
import { ContactsEditComponent } from './components/contacts-edit/contacts-edit.component';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ToastModule } from 'primeng/toast';
//import { ModalContentComponent } from '../shared/modal-component/modal.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { EditLanguageComponent } from './components/edit-language/edit-language.component';
import { EditEngagementMemoryServiceService } from './edit-engagement-memory-service/edit-engagement-memory-service.service';
import { FolderMgmtEditComponent } from './components/folder-mgmt-edit/folder-mgmt-edit.component';
import { EngagementAuthorizationComponent } from './components/engagement-authorization/engagement-authorization.component';
import { TopicCardComponent } from './components/topic-card/topic-card.component';
import {ListboxModule} from 'primeng/listbox';
import { AddNewTopicCardComponent } from './components/add-new-topic-card/add-new-topic-card.component';
import { EditTopicCardComponent } from './components/edit-topic-card/edit-topic-card.component';





@NgModule({
  imports: [
    CommonModule,
    NgMultiSelectDropDownModule,
    FormsModule,
    EditEngagementRoutingModule,
    TreeTableModule,
    PaginatorModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatIconModule,
    MatStepperModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatSnackBarModule,
    EditorModule,
    Editor,
    MatDatepickerModule,
    MatNativeDateModule,
    MultiSelectModule,
    PanelModule,
    CardModule,
    TableModule,
    DropdownModule,
    ButtonModule,
    DialogModule,
    ToggleButtonModule,
    MatTabsModule,
    TreeModule,
    FileUploadModule,
    CalendarModule,
    SidebarModule,
    TabViewModule,
    TooltipModule,
    InputSwitchModule,
    ToastModule,
    ConfirmDialogModule,
    ListboxModule,
   
    // FolderManagementModule
  ],
  declarations: [
    EditEngagementComponent,
    ManageFolderComponent,
    ManageDocComponent,
    UploadNewDocComponent,
    EditDocumentComponent,
   // ModalContentComponent,
    LanguageSelectionComponent,
    BasicDetailsEditComponent,
    ContactsEditComponent,
    EditLanguageComponent,
    FolderMgmtEditComponent,
    EngagementAuthorizationComponent,
    TopicCardComponent,
    AddNewTopicCardComponent,
    EditTopicCardComponent
  ],
 providers: [
    MatDatepickerModule,
    TreeDragDropService,
    RDCServiceModule,
    AppConfigService,
    DatePipe,
    EditEngagementMemoryServiceService,
    ConfirmationService,
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
  //entryComponents: [ModalContentComponent]
})

export class EditEngagementModule { }
